import $ from 'jquery';

function mediaBreakpoints() {
  let media = {
    xxl: 1400,
    xl: 1200,
    lg: 992,
    md: 768,
    sm: 576,
    xs: 375,
  };

  function breakpointsChange(media) {
    if (media.matches) {
      let triggerName = '';
      if (media.triggerName) triggerName = media.triggerName;
      else if (this.triggerName) triggerName = this.triggerName;
      triggerName && $(document).trigger(triggerName);
    }
  }

  for (let size in media) {
    let wdith = media[size];
    let breakpointsDown = window.matchMedia('(max-width: ' + (wdith - 1) + 'px)');
    let breakpointsUp = window.matchMedia('(min-width: ' + wdith + 'px)');
    breakpointsDown.triggerName = 'mediaBreakpointsDown:' + size;
    breakpointsUp.triggerName = 'mediaBreakpointsUp:' + size;
    breakpointsDown.onchange = breakpointsChange;
    breakpointsUp.onchange = breakpointsChange;
    setTimeout(() => {
      breakpointsChange(breakpointsDown);
      breakpointsChange(breakpointsUp);
    }, 100);
  }
}

export default mediaBreakpoints;
